import { render, staticRenderFns } from "./SuiteModule.vue?vue&type=template&id=7b100acb&"
import script from "./SuiteModule.vue?vue&type=script&lang=js&"
export * from "./SuiteModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports